import type { SvgProps } from "../types";

export const ChurchSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Church</title>
      <path
        d="M104 313.231V264.695C104 253.981 104 246.372 104 241.868C104 237.364 116.809 221.081 142.426 193.02H213.549H227.925C227.753 166.838 227.667 152.402 227.667 149.713C227.667 147.025 240.526 134.856 266.243 113.207L297 148.108C297 194.477 296.853 221.791 296.56 230.05C296.266 238.309 296.266 266.74 296.56 315.343"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M244.97 313.059C244.007 298.566 244.428 287.662 246.231 280.347C248.937 269.374 257.026 266.237 261.462 266.237C265.899 266.237 279.87 267.388 279.87 285.554C279.87 297.665 279.87 306.834 279.87 313.059"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M106.284 239.78L134.661 237.687C151.389 238.828 164.409 239.526 173.719 239.78C183.029 240.034 195.573 240.034 211.349 239.78"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.988 282.225C119.988 263.953 123.376 254.816 130.151 254.816C136.926 254.816 140.314 258.71 140.314 266.497L141.687 279.705"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M157.675 279.851C158.691 263.923 161.927 255.958 167.382 255.958C175.563 255.958 177.089 263.506 177.089 270.059C177.089 274.427 177.089 278.483 177.089 282.225"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M194.261 279.941C193.839 264.714 196.554 257.101 202.407 257.101C208.26 257.101 211.24 264.714 211.349 279.941"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M266.737 113.207V84.6567"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M258.171 93.2217H275.302"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M227.337 193.148C228.099 214.809 228.479 233.32 228.479 248.681C228.479 264.042 228.099 285.501 227.337 313.059"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M255.111 160.481C271.287 142.929 289.901 176.301 270.312 185.745C254.983 193.135 245.688 174.583 255.111 163.679"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
